module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133705-1014572293.8db841c0.jpg";